import { BankPaymentDetailDto } from "./bank-payment-detail-dto";


export class BankPayment {

  refNo: string;
  type: string;
  amount: number = 0;
  bankPaymentDetails: BankPaymentDetailDto[] = [];
  bankPayment: BankPaymentDetailDto;

  fromLocationCode: number;
  location: any;
}
